import { render } from "./TeachingStaffView.vue?vue&type=template&id=348e8507"
import script from "./TeachingStaffView.vue?vue&type=script&lang=js"
export * from "./TeachingStaffView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__